// =============================================================================
//  Copyright : 2022 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : parts for vlm support
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {funcPart, loadLazy as ll} from 'uix/parts'

export const VlmVisualEditor = ll(() => import(/* webpackChunkName: 'vlm' */ './visualedit'))
const _VlmCodeEditor = ll(() => import(/* webpackChunkName: 'vlm' */ './plainedit'))
export const VlmCodeEditor = funcPart({partStyle: {overflowX: 'hidden'}}, props => (
  <_VlmCodeEditor {...props} />
))
export const VlmTextTickerEditor = ll(() => import(/* webpackChunkName: 'vlm' */ './ttselect'))
export const VlmDescriptionEditor = ll(() =>
  import(/* webpackChunkName: 'vlm' */ './descriptionedit')
)
export const VlmEngines = ll(() => import(/* webpackChunkName: 'vlm' */ './engines'))
